/* Fog & Form — fog atmosphere.
   Drives --ff-fog-progress (0 → 1) on each [data-ff-fog] from how far the
   visitor has scrolled through its hero, so the fog burns off as they read
   down and settles back when they return. Passive listener, one rAF per
   scroll tick, no layout reads inside the frame beyond a cached height. */
(function () {
  var fogs = [];
  var ticking = false;

  function collect() {
    var nodes = document.querySelectorAll('[data-ff-fog]');
    fogs = [];
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var hero = el.closest('.hero') || el.parentElement;
      fogs.push({ el: el, hero: hero, span: 1, top: 0 });
    }
    measure();
  }

  function measure() {
    var scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    for (var i = 0; i < fogs.length; i++) {
      var f = fogs[i];
      var r = f.hero.getBoundingClientRect();
      f.top = r.top + scrollY;
      // Fully cleared once ~70% of the hero has scrolled past
      f.span = Math.max(1, r.height * 0.7);
    }
  }

  function update() {
    ticking = false;
    var scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    for (var i = 0; i < fogs.length; i++) {
      var f = fogs[i];
      var p = (scrollY - f.top) / f.span;
      if (p < 0) p = 0;
      if (p > 1) p = 1;
      // ease-out so the first bit of scroll thins the fog noticeably
      p = 1 - (1 - p) * (1 - p);
      f.el.style.setProperty('--ff-fog-progress', p.toFixed(3));
    }
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }

  function onResize() {
    measure();
    onScroll();
  }

  function init() {
    collect();
    if (!fogs.length) return;
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize, { passive: true });
    // Re-collect when the theme editor re-renders a section
    document.addEventListener('shopify:section:load', collect);
    document.addEventListener('shopify:section:reorder', onResize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
